export default {
    events: {
        'activities-listing-filters:displayDropdown': 'updateDropdownVisibilityFromEvent',
    },
    methods: {
        updateDropdownVisibilityFromEvent({ params }) {
            const filterCode = params[0];
            if (filterCode === this.filter.code) {
                this.updateVisibility(true);
            }
        },
    },
};
